import React from 'react';
import Error from '../img/404.png';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleReturn = () => {
    navigate('/');
  };

  return (
    <div className="flex flex-col items-center justify-center h-full text-center text-gray-700">
      <img src={Error} alt="error" className='opacity-70 mb-[20px]' />
      <Button
        variant="outlined"
        color="error"
        sx={{
          padding: '3px 10px',
          fontSize: 14,
          whiteSpace: 'nowrap',
          width: '300px'
        }}
        onClick={handleReturn}>
        {t('ReturnToHome')}
      </Button>
    </div >
  );
};

export default NotFound;